import { sendAnalytics } from 'shared/utils/analytics';

export const trackOfferFromHistoryOpen = () => sendAnalytics({ action: 'to_card', label: 'history_offers' });
